import lazyWithReload from 'config/ChunkReload';
import { menuBuilder } from 'services/Routes.service';
import { LicenseIcon } from '@edusynch/edusynch-svg-icons';

const LicensesList = lazyWithReload(() =>
  import('modules/Licenses/LicensesList/LicensesList.container')
);

const LicenseHistoryList = lazyWithReload(() =>
  import(
    'modules/LicenseHistory/LicenseHistoryList/LicenseHistoryList.container'
  )
);

const LicensesMenu = menuBuilder([
  {
    Icon: LicenseIcon,
    name: 'Licenses',
    section: 'menu',
  },
]).addSubmenu([
  {
    type: '',
    name: 'Licenses',
    path: '/licenses',
    exact: true,
    component: LicensesList,
    ability: 'licenses',
  },
  {
    type: '',
    name: 'License History',
    path: '/license-history',
    exact: true,
    component: LicenseHistoryList,
    ability: 'licenses',
  },
]);

export default LicensesMenu;
